<template>
  <div class="fixtures-screenshot-container">
    <div ref="screenshotElement" class="screenshot-content">
      <slot></slot>

      <div class="brand-footer">
        <div class="footer-header">
          <i class="fas fa-users users-icon"></i>
          <p class="footer-title">Join 50,000+ Winners on ballxbet</p>
        </div>
        <p class="footer-subtitle">ကိုယ့်ကိုယ်ကို ယုံကြည်လိုက်ပါ</p>
      </div>
    </div>

    <div class="action-bar">

      <button
        class="action-button share-button"
        :class="type === 'accumulator' ? 'share-accumulator' : 'share-handicap'"
        @click="handleSocialSharing"
      >
        <i class="fas fa-share-alt button-icon"></i>
        Share My Victory&nbsp;&nbsp;🎉
      </button>

      <button class="action-button save-button" @click="handleScreenshot">
        <i class="fas fa-save button-icon"></i>
        Save Screenshot
      </button>
    </div>
  </div>
</template>

<script>
import * as htmlToImage from "html-to-image";

export default {
  name: "FixturesScreenshot",
  props: {
    type: {
      type: String,
      default: "handicap",
      validator: (v) => ["handicap", "accumulator"].includes(v),
    },
  },
  methods: {
    
    async handleSocialSharing() {
      const element = this.$refs.screenshotElement;
      if (!element) return;

      try {
        const dataUrl = await htmlToImage.toPng(element);
        if (!dataUrl) return;

        if (navigator.share) {
          const blob = await (await fetch(dataUrl)).blob();
          const file = new File([blob], "victory-slip.png", { type: "image/png" });

          await navigator.share({
            files: [file],
            title: "My Betting Victory!",
            text: "Check out my winning bet slip!",
          });
        } else {
          console.warn("Sharing not supported on this device.");
        }
      } catch (error) {
        console.error("Sharing failed:", error);
      }
    },

    async handleScreenshot() {
      const element = this.$refs.screenshotElement;
      if (!element) return;

      const saveButton = this.$el.querySelector(".save-button");
      const originalContent = saveButton.innerHTML;

      try {
        saveButton.innerHTML =
          '<i class="fas fa-spinner fa-spin button-icon"></i> Generating...';
        saveButton.disabled = true;

        const dataUrl = await htmlToImage.toPng(element, {
          quality: 0.95,
          pixelRatio: 2,
        });

        if (!dataUrl) throw new Error("Failed to generate image.");

        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "betting-slip.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Screenshot failed:", error);
      } finally {
        saveButton.innerHTML = originalContent;
        saveButton.disabled = false;
      }
    },
  },
};
</script>

<style scoped>
.fixtures-screenshot-container {
  display: flex;
  flex-direction: column;
}

.screenshot-content {
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.brand-footer {
  background: linear-gradient(to right, #2563eb, #4f46e5);
  padding: 16px;
  color: #fff;
}

.footer-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
}

.users-icon {
  height: 20px;
  width: 20px;
}

.footer-title {
  font-weight: 600;
}

.footer-subtitle {
  text-align: center;
  font-size: 14px;
  color: #dbeafe;
}

.action-bar {
  position: sticky;
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-top: 1px solid #d1d5db;
  background-color: #fff;
  padding: 16px;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}

.back-button {
  cursor: pointer;
  font-size: 20px;
  align-self: flex-start;
}

.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  border-radius: 12px;
  padding: 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease, opacity 0.2s ease;
}

.action-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.button-icon {
  height: 20px;
  width: 20px;
}

.share-handicap {
  background-color: #2563eb;
}

.share-accumulator {
  background-color: #16a34a;
}

.save-button {
  background-color: #2563eb;
}
</style>
